/**
 * Pagination Configuration
 * กำหนดค่า pagination ที่ใช้ทั่วทั้งระบบ
 */

export const PAGINATION_CONFIG = {
  // จำนวนแถวต่อหน้า (default)
  DEFAULT_PAGE_SIZE: 20,

  // ตัวเลือกจำนวนแถวต่อหน้า
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  
  // จำนวนหน้าที่แสดงใน pagination navigation
  MAX_PAGE_NUMBERS: 5,
  
  // หน้าเริ่มต้น
  DEFAULT_PAGE: 1,
  
  // จำนวนแถวสูงสุดที่อนุญาต
  MAX_PAGE_SIZE: 100,
  
  // แสดงข้อมูลสรุป (Showing X to Y of Z results)
  SHOW_SUMMARY: true,
  
  // แสดงปุ่มไปหน้าแรก/หน้าสุดท้าย
  SHOW_FIRST_LAST: true,

  // Limit สำหรับ Dropdown/Select - ใช้ค่าที่ backend ยอมรับ
  // สำหรับ endpoint ที่รับ max le=100 (users, devices, brands, sims, etc.)
  DROPDOWN_LIMIT: 100,

  // สำหรับ endpoint ที่รับ max le=1000 (companies, sites, contracts)
  DROPDOWN_LIMIT_LARGE: 1000,

  // Text labels
  LABELS: {
    FIRST: 'หน้าแรก',
    LAST: 'หน้าสุดท้าย',
    PREVIOUS: 'ก่อนหน้า',
    NEXT: 'ถัดไป',
    SHOWING: 'แสดง',
    TO: 'ถึง',
    OF: 'จาก',
    RESULTS: 'รายการ',
    ROWS_PER_PAGE: 'แถวต่อหน้า',
    PAGE: 'หน้า',
    NO_DATA: 'ไม่พบข้อมูล'
  }
};

// Helper function to get page info
export const getPageInfo = (currentPage: number, pageSize: number, totalItems: number) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalItems);
  const showingFrom = totalItems > 0 ? startIndex + 1 : 0;
  const showingTo = endIndex;
  
  return {
    currentPage,
    pageSize,
    totalItems,
    totalPages,
    startIndex,
    endIndex,
    showingFrom,
    showingTo,
    hasNextPage: currentPage < totalPages,
    hasPreviousPage: currentPage > 1
  };
};

// Helper function to get page numbers to display
export const getPageNumbers = (currentPage: number, totalPages: number): number[] => {
  const maxPages = PAGINATION_CONFIG.MAX_PAGE_NUMBERS;
  const pages: number[] = [];
  
  if (totalPages <= maxPages) {
    // แสดงทุกหน้า
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    // แสดงหน้ารอบๆ หน้าปัจจุบัน
    const halfPages = Math.floor(maxPages / 2);
    let start = Math.max(1, currentPage - halfPages);
    let end = Math.min(totalPages, start + maxPages - 1);
    
    // ปรับ start ถ้า end ถึงหน้าสุดท้ายแล้ว
    if (end === totalPages) {
      start = Math.max(1, end - maxPages + 1);
    }
    
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
  }
  
  return pages;
};

// Export type for pagination params
export interface PaginationParams {
  page?: number;
  limit?: number;
  sort?: string;
  order?: 'asc' | 'desc';
}

// Export default pagination params
export const getDefaultPaginationParams = (): PaginationParams => ({
  page: PAGINATION_CONFIG.DEFAULT_PAGE,
  limit: PAGINATION_CONFIG.DEFAULT_PAGE_SIZE
});